import _isEmpty from 'lodash/isEmpty';

import { METADATA_KEY_GUMLET } from 'components/modules/files/constants/business-file-configuration';
import { PLACEHOLDER_MAX_SIZE } from 'components/modules/files/constants/placeholder-images';
import { createQueryParams } from 'components/modules/files/services/gumlet';
import Utils from 'libs/utils';

import { getImageUrl, isRemoteUrl } from './files';

function getPlaceholderImageDimensions({ width, height }, { maxSize = PLACEHOLDER_MAX_SIZE } = {}) {
  let finalWidth = width;
  let finalHeight = height;

  if (!!width && !!height) {
    // Keep aspect ratio with a max value of PLACEHOLDER_MAX_SIZE in the biggest dimension
    const maxDimension = Math.max(width, height);
    if (maxDimension > maxSize) {
      if (width > height) {
        finalWidth = maxSize;
        finalHeight = Math.round((height / width) * maxSize);
      } else {
        finalHeight = maxSize;
        finalWidth = Math.round((width / height) * maxSize);
      }
    }
  } else if (width) {
    finalWidth = Math.min(width, maxSize);
  } else if (height) {
    finalHeight = Math.min(height, maxSize);
  } else {
    finalWidth = maxSize;
  }
  return { width: finalWidth, height: finalHeight };
}

function getResizedImageUrlFromGumletQueryParams(
  url,
  gumletMetadata,
  { maxSize = PLACEHOLDER_MAX_SIZE } = {},
) {
  const { desktop = {} } = gumletMetadata;
  const { width, height, ...rest } = desktop;
  const { width: finalWidth, height: finalHeight } = getPlaceholderImageDimensions(
    {
      width,
      height,
    },
    { maxSize },
  );
  const queryParams = createQueryParams({ width: finalWidth, height: finalHeight, ...rest });
  return queryParams ? `${url}${queryParams}` : url;
}

function getResizedImageUrl(validUrl, metadata, { maxSize = PLACEHOLDER_MAX_SIZE } = {}) {
  if (Object.keys(metadata).includes(METADATA_KEY_GUMLET)) {
    return getResizedImageUrlFromGumletQueryParams(validUrl, metadata[METADATA_KEY_GUMLET], {
      maxSize,
    });
  }
  return Utils.addImageQueryParam(validUrl, 'width', maxSize);
}

export function getPlaceholderImage(image, { metadata = {}, maxSize = PLACEHOLDER_MAX_SIZE } = {}) {
  const validUrl = getImageUrl(image);
  if (_isEmpty(validUrl)) {
    return null;
  }
  if (!isRemoteUrl(validUrl)) {
    return validUrl;
  }

  return getResizedImageUrl(validUrl || '', metadata || {}, { maxSize });
}
